import React from 'react';
import styled from 'styled-components';
import { useZakeke } from '@zakeke/zakeke-configurator-react';
import { ReactComponent as AISolid } from '../../assets/icons/ai.svg';

interface DesignWithAIButtonProps {
	id?: string;
	$isArIconVisible?: boolean;
	onClick: () => void;
}

export const DesignWithAIButton: React.FC<DesignWithAIButtonProps> = ({ id, $isArIconVisible, onClick }) => {
	const { isAIEnabled, product } = useZakeke();

	if (!product?.isAiConfigurationEnabled || !isAIEnabled) {
		return null;
	}

	return (
		<AIButtonContainer id={id} $isArIconVisible={$isArIconVisible} onClick={onClick}>
			<AISolid />
		</AIButtonContainer>
	);
};

const AIButtonContainer = styled.div<{ $isArIconVisible?: boolean }>`
	width: 36px;
	height: 36px;
	cursor: pointer;
	position: absolute;
	top: 20px;
	right: ${(props) => (props.$isArIconVisible ? '50px' : '10px')};
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(255, 255, 255, 0.9);
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	transition: all 0.2s;

	svg {
		width: 24px;
		height: 24px;
	}

	@media (hover) {
		&:hover {
			background: rgba(255, 255, 255, 1);
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		}
	}
`;
